import { render, staticRenderFns } from "./editDeliver.vue?vue&type=template&id=548543cd&scoped=true&"
import script from "./editDeliver.vue?vue&type=script&lang=js&"
export * from "./editDeliver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548543cd",
  null
  
)

export default component.exports